import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { StatusbarService } from './vscode/src/vs/workbench/browser/parts/statusbar/statusbarPart.js';
import { IStatusbarService } from 'vscode/vscode/vs/workbench/services/statusbar/browser/statusbar.service';
import { IExtensionStatusBarItemService, ExtensionStatusBarItemService } from 'vscode/vscode/vs/workbench/api/browser/statusBarService';
import './vscode/src/vs/workbench/api/browser/statusBarExtensionPoint.js';

function getServiceOverride() {
    return {
        [( IStatusbarService.toString())]: new SyncDescriptor(StatusbarService, [], false),
        [( IExtensionStatusBarItemService.toString())]: new SyncDescriptor(ExtensionStatusBarItemService, [], false)
    };
}

export { getServiceOverride as default };
